var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cookie-law', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (props) {
        return _c('div', {
          staticClass: "flex flex-col space-y-5 lg:space-y-0 lg:flex-row lg:space-x-5 items-center"
        }, [_c('p', {
          staticClass: "text-base"
        }, [_vm._v("\n      En poursuivant votre navigation, sans changer les paramètres de votre navigateur, vous acceptez l'utilisation de cookies pour garantir une bonne expérience sur notre site.\n    ")]), _vm._v(" "), _c('a', {
          staticClass: "text-base",
          attrs: {
            "target": "_blank",
            "href": "https://www.neopass.fr/politique-de-confidentialite%e2%80%8b/"
          }
        }, [_vm._v("\n      Politique de confidentialité\n    ")]), _vm._v(" "), _c('div', {
          staticClass: "flex space-x-5 justify-center"
        }, [_c('action-button', {
          attrs: {
            "border-color": "border-transparent",
            "text-color": "text-white",
            "bg-color": "bg-pink-600",
            "bg-color-square": "bg-pink-600",
            "icon-color": "text-white",
            "libelle": "Ignorer",
            "uppercase": true
          },
          on: {
            "clickAction": props.close
          }
        }), _vm._v(" "), _c('action-button', {
          attrs: {
            "border-color": "border-transparent",
            "text-color": "text-white",
            "bg-color": "bg-indigo-600",
            "bg-color-square": "bg-indigo-600",
            "icon-color": "text-white",
            "libelle": "Accepter",
            "uppercase": true
          },
          on: {
            "clickAction": props.accept
          }
        })], 1)]);
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }